import { io, Socket } from 'socket.io-client';
import store from '@store/index';

let socket: Socket | null = null;

const getBaseSocketUrl = () => {
    const apiUrl = import.meta.env.VITE_APP_API_URL;
    const url = new URL(apiUrl);
    return `${url.protocol}//${url.host}`;
};

export const getInternalSupportSocket = (): Socket => {
    if (socket && socket.connected) {
        return socket;
    }

    const token = store.getState().auth.token;
    const baseUrl = getBaseSocketUrl();

    socket = io(baseUrl, {
        auth: { token },
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: 5,
    });

    socket.on('connect_error', (error) => {
        console.error('Socket connection error:', error);
    });

    return socket;
};

export const joinInternalSupportTicketRoom = (ticketId: string) => {
    const sock = getInternalSupportSocket();
    sock.emit('pulse-internal-ticket:join', ticketId);
};

export const leaveInternalSupportTicketRoom = (ticketId: string) => {
    const sock = getInternalSupportSocket();
    sock.emit('pulse-internal-ticket:leave', ticketId);
};

export const disconnectInternalSupportSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};
